import { ReactElement, useContext } from "react"
import { ZipProjectContext } from "./ZipProjectContext"
import { ProjectPerspective } from "../enumerators";
import { ZipCodeDisplayModel } from "./interfaces/zipCodeDisplayModel";
import { QESButton } from "@app/shared/qes-standards/Button";

export const ExcludeZeroMembership = (): ReactElement => {
    const projectContext = useContext(ZipProjectContext);

    const showZeroMembershipButton = (zipCodeDisplayModels: ZipCodeDisplayModel[]) => {
        if (projectContext.state.perspective !== ProjectPerspective.ByZipCode)
            return false;

        if (projectContext.state.adequacyFilters.excludeZeroMembership)
            return true;

        if (!zipCodeDisplayModels && !projectContext.state.adequacyFilters.excludeZeroMembership)
            return false;

        if (zipCodeDisplayModels.find(zipCodeDisplayModel => zipCodeDisplayModel.membershipCount == 0))
            return true;

        return false;
    };

    return (
        showZeroMembershipButton((projectContext.state.zipDetails as ZipCodeDisplayModel[])) ?
            <QESButton
                disabled={projectContext.state.loading}
                onClick={() => projectContext.onChangeExcludeZeroMembership(!projectContext.state.adequacyFilters.excludeZeroMembership)}
                qesTestId="exclude-zero-membership"
                qesType="secondary"
            >
                {projectContext.state.adequacyFilters.excludeZeroMembership ? 'Show 0 Membership' : 'Hide 0 Membership'}
            </QESButton>
            : <></>
    );

};
